/* tslint:disable */
/* eslint-disable */
export enum FejlDashboardTypeEnum {
  FejletOverfoersel = 'FejletOverfoersel',
  FejletOrdreAfregning = 'FejletOrdreAfregning',
  FejletDannelseAfEftersynKreditstop = 'FejletDannelseAfEftersynKreditstop',
  FejletDannelseAfEftersynFlereEftersyn = 'FejletDannelseAfEftersynFlereEftersyn',
  CustomerOpkraevningHalted = 'CustomerOpkraevningHalted',
  CreateEftersynHalted = 'CreateEftersynHalted',
  SlutopgoerelserHalted = 'SlutopgoerelserHalted',
  Serviceintervaller = 'Serviceintervaller',
  PostnummerUdenPartner = 'PostnummerUdenPartner',
  AfregningerHalted = 'AfregningerHalted'
}
